import usePrivateAxios from "@/common/api/usePrivateAxios";
import { BulkActionEntryData } from "@/common/types/bulkActions/entry.type";
import { useQuery } from "@tanstack/react-query";

export const useBulkActionsEntry = (id?: string, keepRefreshing?: boolean) => {
  const privateAxios = usePrivateAxios();

  return useQuery<{ data: { data: BulkActionEntryData; }; }, unknown, BulkActionEntryData>({
    enabled: !!id,
    queryKey: ['bulkActionsEntry', id],
    queryFn: () => privateAxios.get(`/bulk_actions/entries/${id}`),
    select: (data) => data?.data?.data,
    refetchInterval: keepRefreshing ? 3000 : 0,
  });
};
